// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bhc_a bhs_ea bhs_a","LoadingSwitch__init":"bhc_b bhs_a bhs_w bhs_j bhs_ul bhs_um bhs_fm"};